import React from 'react';
import { Modal } from 'react-bootstrap';
import { Button } from '..';
import { TranslationUtils } from '../../utils';
import './PoolHeatModal.scss';
import { ImageLateCheckOut } from '../../assets/images';
import { AppRoutes } from '../../routes';
import { useHistory } from 'react-router-dom';

interface PoolHeatModalProps {
    show: boolean;
    handleClose: () => void;
}

export const PoolHeatModal: React.FC<PoolHeatModalProps> = ({ show, handleClose }) => {
    const history = useHistory();

    const onClick = () => {
        history.push({
            pathname: AppRoutes.MODIFY_TRIP_ADJUSTMENTS.replace(':adjustment', 'pool-heat'),
        });
    };

    return (
        <Modal show={show} onHide={handleClose}>
            <Modal.Header closeButton />

            <div className="pool-heat-modal">
                <div className="modal-body">
                    <div className="modal-text">
                        <h4>
                            {TranslationUtils.get('pool_heat')} {TranslationUtils.get('add_on')}
                        </h4>
                        <p>{TranslationUtils.get('pool_heat_note')}</p>
                    </div>
                    <div className="pool-heat-modal-image">
                        <ImageLateCheckOut />
                    </div>
                </div>

                <div className="modal-buttons">
                    <Button
                        id="button-cancel-pool-heat"
                        variant="default"
                        label={TranslationUtils.get('no_thanks')}
                        onClick={handleClose}
                    />

                    <Button id="button-purchase-pool-heat" variant="primary" label={TranslationUtils.get('purchase')} onClick={onClick} />
                </div>
            </div>
        </Modal>
    );
};
